<div class="col-xs-12 table-details">    
    <div class="col-xs-12 col-sm-3 p0">
        <ul  class="mi-auto-menu">        
            <li *ngFor="let element of listGroupEvent">
                <div *ngIf='element.CountEvent =="0"'>
                    <a (click)="clearTable()">{{element.EventDescription}}</a> 
                </div>
                <div *ngIf='element.CountEvent !="0"'>
                    <a (click)="next(element.DetailEvent)" id="{{element.GroupEvent}}">{{element.EventDescription}}<div *ngIf='element.CountEvent !="0"' class="number"><span class="count">{{element.CountEvent}}</span></div></a>
                </div>           
            </li>
        </ul>   
    </div>
    <div *ngIf='!noDataTabla'>
        <div class="col-xs-12 col-sm-9 p0">
            <div class="table-container table-desktop table-mi-auto">
                <table class="table table-striped table-hover">
                    <thead class="thead-blue">
                        <tr>
                            <th style="width: 50%;" scope="col">Problema</th>
                            <th style="width: 25%;"scope="col">Abrió</th>
                            <th style="width: 25%;"scope="col">Cerrado</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- <tr class="clickable-row" data-href="#problema">
                            <td colspan="3">
                                <p></p>
                            </td>                        
                        </tr> -->
                    </tbody>
            </table>
            </div>
        </div>            
    </div>
    <div *ngIf='noDataTabla'>
        <div class="col-xs-12 col-sm-9 p0">
            <div class="table-container table-desktop table-mi-auto">
                <table class="table table-striped table-hover">
                    <thead class="thead-blue">
                        <tr>
                            <th style="width: 50%;" scope="col">Problema</th>
                            <th style="width: 25%;"scope="col">Abrió</th>
                            <th style="width: 25%;"scope="col">Cerrado</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="clickable-row" data-href="#problema" *ngFor="let event of selectedEvents">
                            <td>
                                <p>{{event.EventDescription}}</p>
                            </td>
                            <td>
                                <p class="fechaApertura">{{event.MinTimestampGMT}}</p>
                            </td>
                            <td>
                                <p class="fechaCierre">{{event.MaxTimestampGMT}}</p>
                            </td>
                        </tr>
                    </tbody>
            </table>
            </div>
        </div>            
    </div>
</div>